import { revitAdvantages } from "@/mocks/serviceRevitData";

export default function RevitAdvantages() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Ventajas
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Ventajas de trabajar con Revit
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            El modelado en Revit aporta precisión, control y coordinación en cada etapa del proyecto.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {revitAdvantages.map((advantage, i) => (
            <div
              key={advantage.title}
              className="reveal rounded-xl border border-background-200 bg-background-50 p-6 hover:border-[#0087a4]/40 transition-colors text-center"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-12 h-12 rounded-full bg-[#0087a4]/10 text-[#0087a4] flex items-center justify-center mb-4 mx-auto">
                <i className={`${advantage.icon} text-2xl`} />
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 leading-snug">
                {advantage.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{advantage.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}